import { Operator } from "@skilitics/judy";

/**
 * The operators a locale comparison offers. A language code is only ever the
 * active one or not — `contains` and `matches` are substring tests over an
 * opaque token. A subset of `stringOperators`, since a locale is a string.
 */
export const localeOperators = [Operator.EQ, Operator.NE] as const;
